module.exports = __webpack_public_path__ + "media/130.88aed844.mp3";